import { Layout, Space } from "antd";
import Cookies from "js-cookie";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import apiFactory from "../../api";
import { registerToken } from "../../api/fcm";
import { useInfoUser } from "../../store/UserStore";
import "./style.scss";
import { useAuthLayoutContext } from "../../context/AuthLayoutContext";
import { initCallingSocket } from "../../api/webSocketRx";
import {useEffect} from "react";

const REACT_APP_AUTHENTICATION_WEB =
  process.env.REACT_APP_AUTHENTICATION_WEB || "http://localhost:4005";

const CallingLayout = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, updateUser, updateLanguageMap, updateStickerKeywords } =
    useInfoUser();
  const { verified } = useAuthLayoutContext();

  const getMe = async () => {
    if (user) return;

    const me = await apiFactory.userApi.getMe();
    if (me?.status === 200) {
      updateUser(me?.data?.user);
      updateLanguageMap(me?.data?.languageMap);
      updateStickerKeywords(me?.data?.stickerKeywords);
      await registerToken(me?.data?.user?.userId);
    } else {
      toast.error(me?.message);
      updateUser(null);
      updateLanguageMap(null);
      Cookies.remove("access_token");
      navigate("/login");
    }
  };

  const getAccessToken = async () => {
    if (user) return;

    const result = await apiFactory.authApi.getAccessToken({
      refreshToken: Cookies.get("refresh_token"),
    });
    if (result?.status === 200) {
      Cookies.set("access_token", result?.data);
    }
  };

  const process = async () => {
    initCallingSocket();
  };

  // useEffect(() => {
  //   process();
  // }, []);

  return (
    <Space className="space-app" direction="vertical" size={[0, 48]}>
      {verified && (
        <Layout className="layout-app">
          <Layout.Content>
            <Outlet />
          </Layout.Content>
        </Layout>
      )}
    </Space>
  );
};

export default CallingLayout;
